import { global } from "./global";
import { horizontalBarChart } from "./horizontal_bar_chart";

export const uiConstants = {
  global,
  horizontalBarChart
};
